export default __webpack_public_path__ + "static/Inter-Bold-07cea5a311575f2c627f72d865fc758d.woff2";